import { SAVE_ERROR_REPONSE_YOUR_NAME_MESSAGE } from "./action";

export function yourNameMessageContactReducer(state = null, action) {
  switch (action.type) {
    case SAVE_ERROR_REPONSE_YOUR_NAME_MESSAGE:
      return action.payload;

    default:
      return state;
  }
}

export default yourNameMessageContactReducer;
